import React, { Component } from "react";
import { Space } from "@masterteam/mt-design-react";
import AsyncImg from "../AsyncImg";
import UserAvatar from "../../assets/images/user_avater.png";
import "./style.scss";
class UserInfo extends Component {
  render() {
    const { title, item, style = {} } = this.props;
    return (
      <Space align="center" className="user-info-container">
        <AsyncImg
          fallback={UserAvatar}
          user={item}
          alt="icon"
          className="user-image"
          style={{
            ...style
          }}
        />
        <div className="owner-container">
          <div className="bold owner-chammp">{item.DisplayName}</div>
          <div className="bold owner-chammp">{title}</div>
        </div>
      </Space>
    );
  }
}
export default UserInfo;
